import { object, string, number } from 'yup'

const resumeSchema = object().shape({
  conteudo_aplicado_vida: string()
    .required('Campo obrigatório!')
    .min(3, 'Obrigatório no mínimo 3 caracteres!')
    .max(300, 'Limite de caracteres(300) foi ultrapassado!'),
  obra_id: number().typeError('Valor inválido!').required('Campo obrigatório!'),
  resumo: string()
    .min(900, 'Mínimo de caracteres não atendido!')
    .max(4000, 'Limite de caracteres ultrapassado!'),
  mes_id: number().typeError('Data inválida!').required('Campo obrigatório!')
})

export default resumeSchema
